import { c as _c } from "react/compiler-runtime";
import { CartOrWishlist_Tabs } from './shared.client';
export const CartOrWishlist_Layout: React.FC<{
  tab: CartOrWishlist_Tabs.Tab;
  header?: React.ReactNode;
  children: React.ReactNode;
  aside?: React.ReactNode;
  footer?: React.ReactNode;
}> = props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.tab) {
    t0 = <CartOrWishlist_Tabs tab={props.tab} />;
    $[0] = props.tab;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children) {
    t1 = <main className="flex-1">{props.children}</main>;
    $[2] = props.children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.aside) {
    t2 = <aside className="max-w-xs xl:max-w-md">{props.aside}</aside>;
    $[4] = props.aside;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="mb-20 lg:flex lg:justify-between lg:gap-x-20">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props.footer || $[10] !== props.header || $[11] !== t0 || $[12] !== t3) {
    t4 = <div>{t0}{props.header}{t3}{props.footer}</div>;
    $[9] = props.footer;
    $[10] = props.header;
    $[11] = t0;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};